import { useCallback } from "react";

import { useMapStore } from "stores/map";
import type { LayerStyleSetting } from "stores/map";

export function useUpdateLayerStyle() {
  const setDisplaySettings = useMapStore((s) => s.setDisplaySettings);

  const updateLayerStyle = useCallback(
    (layerName: string, patch: LayerStyleSetting) => {
      setDisplaySettings((current) => {
        const previous = current.layerStyleSettings ?? {};
        return {
          ...current,
          layerStyleSettings: {
            ...previous,
            [layerName]: {
              ...previous[layerName],
              ...patch,
              ...(patch.color !== undefined && { color: patch.color.toLowerCase() })
            }
          }
        };
      });
    },
    [setDisplaySettings]
  );

  return { updateLayerStyle };
}
